<template>
  <footer class="footer">
    <div class="container columns">
      <div class="column">
        <ul>
          <li><h4>Contact Us</h4></li>
          <li><a href="tel:+918879400099">+91-88794-00099</a></li>
          <li><a href="mailto:partha@athcons.com">partha@athcons.com</a></li>
          <li>6E, Sundatta Apartments</li>
          <li>Mount Pleasant Road, Malabar Hill</li>
          <li>Mumbai - 400006</li>
        </ul>
      </div>
      <div class="column">
        <h4>Follow Us</h4>
        <div class="columns">
          <div class="column">
            <a href="https://www.facebook.com/athcons">
              <span class="icon fa-5x fab fa-facebook-square"></span>
            </a>
          </div>
          <div class="column">
            <a
              href="https://www.linkedin.com/company/athena-consulting-where-wisdom-wins"
            >
              <span class="icon fa-5x fab fa-linkedin"></span>
            </a>
          </div>
        </div>
      </div>
      <div class="column">
        <ul>
          <li><h4>Sitemap</h4></li>
          <li><router-link to="/">Home</router-link></li>
          <li><router-link to="/about">About Athena</router-link></li>
          <li><router-link to="/offerings">Offerings</router-link></li>
          <li><router-link to="/presence">Business Presence</router-link></li>
          <li><router-link to="/contact">Contact Us</router-link></li>
        </ul>
      </div>
    </div>
    <p>A BayLeaf Solutions Initiative</p>
  </footer>
</template>

<script>
export default {
  name: "Navbar",
  props: {},
};
</script>
